import React, { useMemo, useState } from 'react';
import clsx from 'clsx';
import { observer } from 'mobx-react';

const BasketballMatchGameSpecial = observer(({ item }) => {
  const [selectedPeriod, setSelectedPeriod] = useState(1);
  const { periodSpecial } = item;

  const special = useMemo(() => {
    const matchSpecial = periodSpecial.filter(
      (item) => item.period === +selectedPeriod
    )[0];

    let result = {
      home: {
        firstFive: false,
        firstFreeThrow: false,
        firstPoint: false,
        firstSeven: false,
        firstTen: false,
        firstThreePoint: false
      },
      away: {
        firstFive: false,
        firstFreeThrow: false,
        firstPoint: false,
        firstSeven: false,
        firstTen: false,
        firstThreePoint: false
      }
    };

    if (!!matchSpecial) {
      Object.keys(matchSpecial).forEach((key) => {
        if (key !== 'period') {
          if (matchSpecial.hasOwnProperty(key)) {
            if (!!matchSpecial[key]) {
              result[matchSpecial[key].toLowerCase()][key] = true;
            }
          }
        }
      });
    }

    return result;
  }, [periodSpecial, selectedPeriod]);

  const onChangePeriod = (e) => {
    setSelectedPeriod(e.target.value);
  };

  return (
    <div className="special_board">
      <div className="special_option">
        <select onChange={onChangePeriod}>
          <option value="1">1쿼터</option>
          <option value="2">2쿼터</option>
          <option value="3">3쿼터</option>
          <option value="4">4쿼터</option>
        </select>
      </div>
      <dl className="item">
        <dt>첫득점</dt>
        <dd className={clsx(special.away.firstPoint && 'on')}></dd>
        <dd className={clsx(special.home.firstPoint && 'on')}></dd>
      </dl>
      <dl className="item">
        <dt>첫3</dt>
        <dd className={clsx(special.away.firstThreePoint && 'on')}></dd>
        <dd className={clsx(special.home.firstThreePoint && 'on')}></dd>
      </dl>
      <dl className="item">
        <dt>첫자</dt>
        <dd className={clsx(special.away.firstFreeThrow && 'on')}></dd>
        <dd className={clsx(special.home.firstFreeThrow && 'on')}></dd>
      </dl>
      <dl className="item">
        <dt>선5</dt>
        <dd className={clsx(special.away.firstFive && 'on')}></dd>
        <dd className={clsx(special.home.firstFive && 'on')}></dd>
      </dl>
      <dl className="item">
        <dt>선7</dt>
        <dd className={clsx(special.away.firstSeven && 'on')}></dd>
        <dd className={clsx(special.home.firstSeven && 'on')}></dd>
      </dl>
      <dl className="item">
        <dt>선10</dt>
        <dd className={clsx(special.away.firstTen && 'on')}></dd>
        <dd className={clsx(special.home.firstTen && 'on')}></dd>
      </dl>
    </div>
  );
});

export default BasketballMatchGameSpecial;
